import CustomCard from '../../../components/CustomCard.tsx'
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs'
import styles from '../../../styles/components/register.module.scss'
import { useFormContext } from 'react-hook-form'

export const AddressData = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext()

  const requiredMsg = 'Dieses Feld ist ein Pflichtfeld'

  return (
    <CustomCard header="Adresse">
      <div className="formRow">
        <div>
          <TextBoxComponent placeholder="Straße" cssClass={`${styles.required}`} floatLabelType="Always" {...register('adrStreet', { required: requiredMsg })} />
          <p className="errorMsg">{(errors.adrStreet?.message as string) || null}</p>
        </div>
      </div>
      <div className="formRow">
        <div className="formRow">
          <div>
            <TextBoxComponent placeholder="Land" cssClass={`${styles.required}`} floatLabelType="Always" {...register('adrCountry', { required: requiredMsg })} />
            <p className="errorMsg">{(errors.adrCountry?.message as string) || null}</p>
          </div>
          <div>
            <TextBoxComponent
              placeholder="PLZ"
              cssClass={`${styles.required}`}
              floatLabelType="Always"
              {...register('adrPostCode', {
                required: requiredMsg,
                pattern: {
                  value: /^\d{5}$/,
                  message: 'Ungültiges PLZ-Format.',
                },
              })}
            />
            <p className="errorMsg">{(errors.adrPostCode?.message as string) || null}</p>
          </div>
        </div>

        <div>
          <TextBoxComponent placeholder="Ort" cssClass={`${styles.required}`} floatLabelType="Always" {...register('adrTown', { required: requiredMsg })} />
          <p className="errorMsg">{(errors.adrTown?.message as string) || null}</p>
        </div>
      </div>
    </CustomCard>
  )
}
